import script from "./RoomCurtainDeviceItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomCurtainDeviceItem.vue?vue&type=script&setup=true&lang=js"

import "./RoomCurtainDeviceItem.vue?vue&type=style&index=0&id=169b142a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169b142a"]])

export default __exports__